import { render, staticRenderFns } from "./JavaTaskDetail.vue?vue&type=template&id=3b3a9078&"
import script from "./JavaTaskDetail.vue?vue&type=script&lang=js&"
export * from "./JavaTaskDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b3a9078')) {
      api.createRecord('3b3a9078', component.options)
    } else {
      api.reload('3b3a9078', component.options)
    }
    module.hot.accept("./JavaTaskDetail.vue?vue&type=template&id=3b3a9078&", function () {
      api.rerender('3b3a9078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gva-wfd/components/DetailPanel/JavaTaskDetail.vue"
export default component.exports